import React from 'react';
import {
	TableCell,
	TableRow as TableRowMui,
	IconButton,
} from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import styled from 'styled-components';

const Row = (props) => {
	const { row, onClickEdit } = props;

	const handleOnClickEdit = () => {
		onClickEdit(row);
	};

	return (
		<React.Fragment>
			<TableRow onClick={handleOnClickEdit}>
				<TableCell align="left">{row.name}</TableCell>
				<TableCell align="left">{row.information}</TableCell>
				<TableCell align="center">{row.created}</TableCell>
				<TableCell align="center">{row.accountList.length}</TableCell>
				<TableCell align="center">
					<IconButton size="small" onClick={handleOnClickEdit}>
						<ListAltIcon />
					</IconButton>
				</TableCell>
			</TableRow>
		</React.Fragment>
	);
};

const TableRow = styled(TableRowMui)`
	cursor: pointer;
	&:hover {
		background-color: #0091ae1f;
	}
`;

export default Row;